var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" 版权所有 Copyright © 2005 福建师大附中（Fjsdfz.com） 闽ICP备19018342号 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }